import { render, staticRenderFns } from "./RememberPassword.vue?vue&type=template&id=6a70c782"
import script from "./RememberPassword.vue?vue&type=script&lang=js"
export * from "./RememberPassword.vue?vue&type=script&lang=js"
import style0 from "./RememberPassword.vue?vue&type=style&index=0&id=6a70c782&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a70c782')) {
      api.createRecord('6a70c782', component.options)
    } else {
      api.reload('6a70c782', component.options)
    }
    module.hot.accept("./RememberPassword.vue?vue&type=template&id=6a70c782", function () {
      api.rerender('6a70c782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/sessions/RememberPassword.vue"
export default component.exports